import { useIntl } from "react-intl";
import { Button } from 'primereact/button';
import { format, parseISO } from 'date-fns';
import { TransferStatus, Priority } from "../../views/StretcherBearerView";
import { Icon } from '@iconify/react';
import "./TransferRequestCard.scss"

export const TransferRequestCard = ({ record, handleClick, userId, details, userAllowedToAssignUnassign, showTimes }: { record: any; handleClick?: any; userId: any; details?: boolean; userAllowedToAssignUnassign?: boolean, showTimes?: boolean }) => {
    const intl = useIntl();
    const isInProgress = record.currentstatus === TransferStatus.INPROGRESS;
    const priorityColor = record.priority === Priority.URGENT ? 'red' : 'yellow';
    const iconArrowsStyle = {
        color: isInProgress ? 'white' : 'black',
        backgroundColor: isInProgress ? '#1E9B00' : '',
        fontSize: '38px',
        padding: '8px',
        borderRadius: '20%',
    };
    const buttonStylePending = {
        width: '96%',
        marginTop: '10px',
        marginLeft: '2%',
        marginBottom: '7px',
        backgroundColor: '#14C7BC',
        color: 'white',
        border: 'none' 
    };

    if (!details){
        return (
            <div className={`transfer-request-card round-with-shadow ${isInProgress ? 'pending' : 'in-progress'} mb-2`}>
                <button disabled={record.currentstatus === TransferStatus.PENDING || record.currentstatus === TransferStatus.FINISHED || record.currentstatus === TransferStatus.CANCELLED || (record._userstretbearer !== null && record._userstretbearer != userId && !userAllowedToAssignUnassign)} style={{background:'transparent', border:'none', width:'100%'}} onClick={() => record.currentstatus === TransferStatus.INPROGRESS? handleClick(record) : ''}>
                    <div className="card-status color-card-status">
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '5px' }}>
                            <Icon icon='bi:circle-fill' color={priorityColor} />
                            <span style={{marginLeft: '5px'}}>{record.prioritydescription.toUpperCase()}</span>
                        </div>
                        <span>{intl.formatMessage({ id: 'NumOrder' })}: <strong>{record.patienttransfer}</strong></span>
                    </div>
                    <div className="card-content">
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Icon icon='bi:arrow-left-right' style={iconArrowsStyle}/>
                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                                <span>{intl.formatMessage({ id: 'Origin' })}: <strong>{record.namecurrentsector}</strong></span>
                                <span>{intl.formatMessage({ id: 'Destiny' })}: <strong>{record.namenewsector}</strong></span>
                            </div>
                        </div>
                        <div className="data-container" style={{marginTop: '10px', marginBottom: '8px'}}>
                            {record.currentstatus === TransferStatus.INPROGRESS && (
                            <span style={{ color: '#2B8840', fontWeight: 'bold', marginTop: '4px' }}>
                                {intl.formatMessage({ id: 'InProgress' }) || 'En curso'}
                            </span>
                            )}
                            {record.currentstatus === TransferStatus.PENDING && (
                            <span style={{ color: '#B27668', fontWeight: 'bold', marginTop: '4px' }}>
                                {intl.formatMessage({ id: 'Pending' }) || 'Pendiente'}
                            </span>
                            )}
                            <span style={{color: 'black', fontWeight: 500}}>{record.clinichistoryid? record.clinichistoryid+' - ':''}{record.fullname}</span>
                            <span>{intl.formatMessage({ id: 'TimeOfRequest' })}: {format(parseISO(record.requestedtime), 'HH:mm')}</span>
                            { record._userstretbearer && (<span>{intl.formatMessage({ id: 'StretcherBearer' })}: {record.stretcherbearername? record.stretcherbearername : record.stretbearerfullname}</span>)}
                        </div>
                        
                    </div>
                </button>
                <Button
                    visible={ record.currentstatus === TransferStatus.PENDING}
                    label={intl.formatMessage({ id: 'TakeTransfer' })}
                    onClick={() => handleClick(record)}
                    style={buttonStylePending}
                />
            </div>
            
        );
    }else{
        return (     
            <div className={`transfer-request-card ${isInProgress ? 'pending' : 'in-progress'} mb-2`}>
                <div className="card-status color-card-status">
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '5px' }}>
                        <Icon icon='bi:circle-fill' color={priorityColor} />
                        <span style={{marginLeft: '5px'}}>{record.prioritydescription.toUpperCase()}</span>
                    </div>
                    <span>{intl.formatMessage({ id: 'NumOrder' })}: <strong>{record.patienttransfer}</strong></span>
                </div>
                <div className="card-content">
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                        <Icon icon='bi:arrow-left-right' style={iconArrowsStyle}/>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                            <span style={{color: 'black'}}>{intl.formatMessage({ id: 'Origin' })}: <strong>{record.namecurrentsector}</strong></span>
                            <span style={{color: 'black'}}>{intl.formatMessage({ id: 'Destiny' })}: <strong>{record.namenewsector}</strong></span>
                        </div>             
                    </div>       
                    <div className="data-container" style={{marginTop: '10px', marginBottom: '8px'}}>
                        {record.currentstatus === TransferStatus.INPROGRESS && (
                        <span style={{ color: '#2B8840', fontWeight: 'bold', marginTop: '4px' }}>
                            {intl.formatMessage({ id: 'InProgress' }) || 'En curso'}
                        </span>
                        )}
                        {record.currentstatus === TransferStatus.PENDING && (
                        <span style={{ color: '#B27668', fontWeight: 'bold', marginTop: '4px' }}>
                            {intl.formatMessage({ id: 'Pending' }) || 'Pendiente'}
                        </span>
                        )}
                        <span style={{color: 'black', fontWeight: 600}}>{record.clinichistoryid? record.clinichistoryid+' - ':''}{record.fullname}</span>
                        {record.fromroomnumber && (<span style={{fontWeight: 500}}>{intl.formatMessage({ id: 'RoomBedOrigin' })}: <span style={{fontWeight: 600, border:'none'}}>{record.fromroomnumber} - {intl.formatMessage({ id: 'Bed' })} {record.frombednumber}</span></span>)}
                        {record.toroomnumber && (<span style={{fontWeight: 500}}>{intl.formatMessage({ id: 'RoomBedDestiny' })}: <span style={{fontWeight: 600, border:'none'}}>{record.toroomnumber} - {intl.formatMessage({ id: 'Bed' })} {record.tobednumber}</span></span>)}
                        <span style={{fontWeight: 500}}>{intl.formatMessage({ id: 'conveyance' })}: {record.conveyance}</span>
                        {record.oxygen && (<span style={{fontWeight: 500}}>{intl.formatMessage({ id: 'RequiresOxygen' })}</span>)}
                        <span>{intl.formatMessage({ id: 'RequestedBy' })}: {record.userfullname}</span>
                        { record._userstretbearer && (<span>{intl.formatMessage({ id: 'StretcherBearer' })}: {record.stretcherbearername? record.stretcherbearername : record.stretbearerfullname}</span>)}
                        <span>{intl.formatMessage({ id: 'TimeOfRequest' })}: {format(parseISO(record.requestedtime), 'HH:mm')}</span>
                        {showTimes && (<div className="data-container">                     
                            <span>{intl.formatMessage({ id: 'TakingTime' })}: {format(parseISO(record.transferfromdate), 'HH:mm')}</span>
                            {record.currentstatus === TransferStatus.FINISHED && (<span>{intl.formatMessage({ id: 'StartTime' })}: {format(parseISO(record.transferdatefrompatient), 'HH:mm')}</span>)}
                            <span>{intl.formatMessage({ id: 'CompletionTime' })}: {format(parseISO(record.transfertodate), 'HH:mm')}</span>
                        </div>)}
                        {record.observations && (<span>{intl.formatMessage({ id: 'Observations' })}: {record.observations}</span>)}                       
                    </div>
                </div>
            </div>
        );
    }
    
};